import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import EditButton from 'components/buttons/EditButton';
import Heading from 'components/text/Heading';

const CheckoutHeading = ({
    $style = {},
    $textStyling = {},
    editButtonVisible = false,
    fontKeys = ['Secondary/20_100_-0375', null, null, null, null, 'Secondary/24_100_-03'],
    label = '',
    onClickEdit = () => null,
    text,
    ...rest
}) => {
    const [css] = useStyletron();

    return (
        <div
            className={css({
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: ['24px var(--margin-content) 12px', null, null, null, null, '24px var(--margin-content)'],
                borderBottom: '1px solid var(--color-border-checkout-subtle)',
                ...$style,
            })}
            {...rest}
        >
            <Heading as="h2" fontKeys={fontKeys}>
                {label}
            </Heading>
            {text && (
                <span
                    className={css({
                        color: 'var(--color-text-subtle)',
                        ...textStyles['Secondary/12_100'],
                        ...$textStyling,
                    })}
                >
                    {text}
                </span>
            )}
            {editButtonVisible && <EditButton $style={textStyles['Misc/16_100_-2']} onClick={onClickEdit} />}
        </div>
    );
};

CheckoutHeading.propTypes = {
    $style: PropTypes.object,
    $textStyling: PropTypes.object,
    editButtonVisible: PropTypes.bool,
    fontKeys: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    label: PropTypes.string,
    onClickEdit: PropTypes.func,
    text: PropTypes.string,
};

export default CheckoutHeading;
